var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakaoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FEE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64559 16.4121L7 17L7.58791 14.3544C7.21272 13.6528 7 12.8513 7 12C7 9.23857 9.23857 7 12 7C14.7614 7 17 9.23857 17 12C17 14.7614 14.7614 17 12 17C11.1487 17 10.3472 16.7873 9.64559 16.4121Z",
    fill: "#29292A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoIcon);
export default __webpack_public_path__ + "static/media/kakao_icon.1af00455c069d17f7cce774544887426.svg";
export { ForwardRef as ReactComponent };